import ModalHealth from './ModalHealth';

export default ModalHealth;
